export default __webpack_public_path__ + "static/iphone-01-11332d2359f7c334834f3b938755b609.png";